
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93z2ulRrSyHEiAZI_45QPu61kAXVIQtxyzT9Tt2nhVlsYzsMeta } from "/app/src/pages/[...slug].vue?macro=true";
import { default as indexW_cgUCxiKEsX3OaTBxYnTPyCj1VkbSbDnLILAJSgxrwMeta } from "/app/src/pages/sign/index.vue?macro=true";
import { default as indexaIvZKiUinKzPWcX_451DuzdmUcwdr_45KqxLB4z_452JO2d_oMeta } from "/app/src/pages/admin/index.vue?macro=true";
import { default as indexMEfzbVVEb8GO8kjTsiwwhkij_459EAb3qez75uIYtV6HQMeta } from "/app/src/pages/forget/index.vue?macro=true";
import { default as indexwQ0whIx6V6QO__452fQ6F7yUrPqrky8Q7byXKWp27tiNsMeta } from "/app/src/pages/submit/index.vue?macro=true";
import { default as indexTzMaNAylP955S0lE9D4403QCGYEEd4736PI_3QWcPBAMeta } from "/app/src/pages/inquire/index.vue?macro=true";
import { default as indexBNM4uTueJp3DaGD_GkH6jtybK42fjjNJMxMR35erPnEMeta } from "/app/src/pages/question/index.vue?macro=true";
import { default as _91id_93E5Vc3RHPRwKjq8ZucZ_X0eQw2nQQuUcLL7jLu7ek3OMMeta } from "/app/src/pages/recording/[id].vue?macro=true";
import { default as indexOaydxna2dgjeAQAgJ5FQQoDerWdOZ4Kl8XBPszjzd_45AMeta } from "/app/src/pages/admin/role/index.vue?macro=true";
import { default as indexKRGDHoNYJuDPM0ps4vzL9h42MYFEWt_A6T2NmURkz0AMeta } from "/app/src/pages/registered/index.vue?macro=true";
import { default as _91id_93n_45thbf4RKLEdlEyNZqErRJptuAGO4e5l5RoBU6e0m6YMeta } from "/app/src/pages/product-list/[id].vue?macro=true";
import { default as indexZ7SxwOlWjEqtYCBP_45BVZAwrioXfIPs1ZtUqTVl2biq4Meta } from "/app/src/pages/admin/account/index.vue?macro=true";
import { default as indexh_2O6cLR31LBdcKHUEdim26AJ0McfzH4xnn4iZBnRgUMeta } from "/app/src/pages/admin/service/index.vue?macro=true";
import { default as indexTCP4QyYYJP5uDm8iHa_Cczy6BQqvIK8X67a54gsJlr0Meta } from "/app/src/pages/admin/personal/index.vue?macro=true";
import { default as _91id_93aF9i4iWA_oEiwIzG0bvSpY9KhrclrLDIsG5KWQl_45RX4Meta } from "/app/src/pages/product-article/[id].vue?macro=true";
import { default as index_NzYC63wGK_o0CY7bKWmrS0vZzw_31JhpgW34FUpAEYMeta } from "/app/src/pages/admin/parameter/index.vue?macro=true";
import { default as indexu1kzx0bNSnMSO_NU2VnfviXuZOdWDnQRas98ndteW9EMeta } from "/app/src/pages/registered-edit/index.vue?macro=true";
import { default as sign_45form01OPjELhiqaGlMlbl6qtanHIm24FmMvk31NQ_45Z5te_45MMeta } from "/app/src/pages/sign/schemas/sign-form.ts?macro=true";
import { default as indexv_45GwsW4mjU89LYZv6alFwrQ_45u622y_45k3OO_1DUj3F3EMeta } from "/app/src/pages/admin/productSub/index.vue?macro=true";
import { default as indexm3QSdkNa6zy9PrVKmAmPnvgb66tbXy45fxGN84dH5C0Meta } from "/app/src/pages/admin/productMain/index.vue?macro=true";
import { default as index0RjoNJYiXXmUlxRZ5uWhi6W1TLUytcSOEClg8Q41nTUMeta } from "/app/src/pages/recording-inquire/index.vue?macro=true";
import { default as forget_45formPHUaBZg1FUqbOacAosIjWPFG3V0eaeL_aQ5R_aGnd34Meta } from "/app/src/pages/forget/schemas/forget-form.ts?macro=true";
import { default as submit_45formeB7HRBVshxFJdWCFXe5YBhoGlMffFGfcDrGOhNF_RDIMeta } from "/app/src/pages/submit/schemas/submit-form.ts?macro=true";
import { default as index57REhusMqHdYlnupBbPTwL1f3qWFBMHl5Mdm4GIuCqIMeta } from "/app/src/pages/admin/productSubPage/index.vue?macro=true";
import { default as _91psID_93Ae3HCo_454cocyYwLz86TrtsFMh9d8E3wPFhgMxqXQ_45Q8Meta } from "/app/src/pages/product-navs/[pmID]/[psID].vue?macro=true";
import { default as role_45formD007qW0RvLBvBQU0r9m8kTzJGb__H_45yKyBtrkCZWRDAMeta } from "/app/src/pages/admin/role/schemas/role-form.ts?macro=true";
import { default as reply_45form0qhXet4P_AAbBjMYHWmh_Mahd6qU5L7TPdVUxAqQ3hQMeta } from "/app/src/pages/recording/components/reply-form.vue?macro=true";
import { default as register_45formjBySXOLbTHr6idXGbCSc4rnuQyRRp1TnbpIXoiy5FtgMeta } from "/app/src/pages/registered/schemas/register-form.ts?macro=true";
import { default as file_45uploaderYYH0NvLxE6jj7xwcTnlI04aHobSjAfIzgnAdiw5BsuMMeta } from "/app/src/pages/submit/components/file-uploader.vue?macro=true";
import { default as account_45formEeW5qRmcAvBZsWufXjIotLZ4mY69AGMIXyb2Uxazc_45gMeta } from "/app/src/pages/admin/account/schemas/account-form.ts?macro=true";
import { default as log_45formu6F2riXwmoKhNK_s_45vHV61AelK_45bGw9x4gLfkJVHGOQMeta } from "/app/src/pages/admin/service/components/log-form.vue?macro=true";
import { default as registered_45formnXXvfZ5J_pPOZgiqLV3PAPeSBTHquA8ZJBrO9wGhnB4Meta } from "/app/src/pages/registered/schemas/registered-form.ts?macro=true";
import { default as search_45panelH_45EKWgxFjqz80ZanT2tdr54WGsI40h1uvLObvRVvep8Meta } from "/app/src/pages/admin/role/components/search-panel.vue?macro=true";
import { default as role_45search_45form4cq8aC1pLGt3GwdsLrHr_45_OwyV4xEcmc6lbRN_a9rFMMeta } from "/app/src/pages/admin/role/schemas/role-search-form.ts?macro=true";
import { default as reply_45form_45schemacoM6HathBbb5CCuwuhL4vWWRVvQT7BkL5Mm3vAxR0joMeta } from "/app/src/pages/recording/schemas/reply-form-schema.ts?macro=true";
import { default as select_45component3pf3QPSETlIuRkSFnnngEeeX7Wek4PyP1tanPlCDK7wMeta } from "/app/src/pages/submit/components/select-component.vue?macro=true";
import { default as form_45dataccAVm3Tz2CgrQ7gqaToFsNnEOM5SMh3NwxY_gUASoBcMeta } from "/app/src/pages/admin/personal/components/form-data.vue?macro=true";
import { default as log_45recordJC_5VrDZ3OXLrwQXJpsaTejLciCiJuww9_LqPRrCMDsMeta } from "/app/src/pages/admin/service/components/log-record.vue?macro=true";
import { default as action_45buttons5q8_Co7NJn69VL_UIkQfDpdIspixxxe9HZJFeXj6Z24Meta } from "/app/src/pages/admin/role/components/action-buttons.vue?macro=true";
import { default as put_45data_45modal25IlcOhUpH34h6_45YTLw6D0UOy3eZ9ivBefgK0Yv7cQcMeta } from "/app/src/pages/admin/role/components/put-data-modal.vue?macro=true";
import { default as alert_45modalFqNWsls638ilVT0dmugPbzmolJF2ObxYLXhm6zAFd74Meta } from "/app/src/pages/admin/service/components/alert-modal.vue?macro=true";
import { default as register_45edit_45formUKOWpxohR8JIdzKSK4R3uXoR0N4ElLojZZe0KFPNokYMeta } from "/app/src/pages/registered/schemas/register-edit-form.ts?macro=true";
import { default as search_45panel_459ZZdH_45YkpQRm_KW6CnhYSfq8ute4qTCro1YdHhximoMeta } from "/app/src/pages/admin/account/components/search-panel.vue?macro=true";
import { default as parameter_45formqLoVamo9ZnTJADRT8eXQiLEu0ZOvhVWVr9UnE3SZE_oMeta } from "/app/src/pages/admin/parameter/schemas/parameter-form.ts?macro=true";
import { default as button_45panelB7LKszI2rd1laN6xRV6Y_YpjFYY4Ylb4frsmsPdbtmMMeta } from "/app/src/pages/admin/service/components/button-panel.vue?macro=true";
import { default as search_45paneleMVDvpqe33GDv9zRNSHY7Tw0KaNHg82YQ513uemaIK0Meta } from "/app/src/pages/admin/service/components/search-panel.vue?macro=true";
import { default as service_45log_45formQIg9wn_45H7S5f1jJ7sjqVL7VxR70js_uQMaI3gXdUPmgMeta } from "/app/src/pages/admin/service/schemas/service-log-form.ts?macro=true";
import { default as content_45coverv36ZOUAn_45VuuKcjHMfxSUdlnUJ6pm5cbvI7ta7Hg2fkMeta } from "/app/src/pages/product-list/components/content-cover.vue?macro=true";
import { default as action_45buttonsq6dh_VxNDpyl_45WlQ4V4V6xGgY48eUrJLIhEfF1lY0mYMeta } from "/app/src/pages/admin/account/components/action-buttons.vue?macro=true";
import { default as put_45data_45modaldmRoHLzmKedjFQFADACme2uyxXNn8V4NHbTdeEtJ1CoMeta } from "/app/src/pages/admin/account/components/put-data-modal.vue?macro=true";
import { default as search_45paneljOtVrNbY16T_45HlgwdBpXezpkwLTRdVo_45HBzlcKmXKxkMeta } from "/app/src/pages/admin/parameter/components/search-panel.vue?macro=true";
import { default as delete_45data_45modalen6tPgyAjLjD5lYYdxZugmcJuAkIZ1cBmWwm_45BRBHdwMeta } from "/app/src/pages/admin/role/components/delete-data-modal.vue?macro=true";
import { default as put_45data_45modal2E0Dw_45H3Pis6oNExbK3cUlcxNiq9MOsHPQ0525R1E80Meta } from "/app/src/pages/admin/service/components/put-data-modal.vue?macro=true";
import { default as service_45issue_45form4FS2K8lqChJ4yCPvwlspWQljX_5MrmhVQK4jaY1R_45aMMeta } from "/app/src/pages/admin/service/schemas/service-issue-form.ts?macro=true";
import { default as feedback_45componentz12du5rQirpwMbjYxDEpIvIrNhkZRHrhTJoW2uKWHzcMeta } from "/app/src/pages/recording/components/feedback-component.vue?macro=true";
import { default as progress_45componenttsuxZgUHQBbkKRZbNB8i05WGAjRNCEMp4LHgQ_oHYBkMeta } from "/app/src/pages/recording/components/progress-component.vue?macro=true";
import { default as account_45search_45formORU3HpWe4Lu8_a1nWmGxJK9cUdIHOaNQVMfQL7RUcvQMeta } from "/app/src/pages/admin/account/schemas/account-search-form.ts?macro=true";
import { default as search_45panell3l_K5XA69MLq0tstQ51PtCVR5E7JKtxv3qYcKXF2Z0Meta } from "/app/src/pages/admin/productSub/components/search-panel.vue?macro=true";
import { default as product_45sub_45formC5DaNKQlFsumJllrxzAaOVHQibwBCQrBGGZKH0OvKoUMeta } from "/app/src/pages/admin/productSub/schemas/product-sub-form.ts?macro=true";
import { default as action_45buttonslA547_6TVEs18x3rsVeRCNoyKr65sI_Sw_45EAT5__45GEsMeta } from "/app/src/pages/admin/parameter/components/action-buttons.vue?macro=true";
import { default as put_45data_45modalp_wexYBzJbxrQ8txwh1XGok5GNqs_onst95R2UdutnQMeta } from "/app/src/pages/admin/parameter/components/put-data-modal.vue?macro=true";
import { default as search_45panelQRk8NWnVTqeDP_45jLJBFoPEuNjyMOZTyjqI7MWiI01isMeta } from "/app/src/pages/admin/productMain/components/search-panel.vue?macro=true";
import { default as sub_45item_45listPgM5NeGvEGpKmGtb3dXHGvnFzQlJAF4DcBZYSDxWvLsMeta } from "/app/src/pages/admin/productSub/components/sub-item-list.vue?macro=true";
import { default as product_45main_45form9jp4CPdM2wzdB8i7F9JyZ0XoGuu_EMUeK_45GM9hYGbl0Meta } from "/app/src/pages/admin/productMain/schemas/product-main-form.ts?macro=true";
import { default as action_45buttonsUnnlPFy2_453kjVQ0jxe26K28sJfrpqTK1z9jgoWKyicwMeta } from "/app/src/pages/admin/productSub/components/action-buttons.vue?macro=true";
import { default as put_45data_45modalxWr0l_59Z5URUyk3M7WXnp8RlO_456rDllVYhHUCfEOWoMeta } from "/app/src/pages/admin/productSub/components/put-data-modal.vue?macro=true";
import { default as action_45buttonsIhuLrIqKwu4nHvFTV23C8Pvke3hhLsdr3LYXU0AoLboMeta } from "/app/src/pages/admin/productMain/components/action-buttons.vue?macro=true";
import { default as put_45data_45modal9AiuvYumZOfjQWfZiYmgrK2DmzTgkt8qNwTXVGQUaP8Meta } from "/app/src/pages/admin/productMain/components/put-data-modal.vue?macro=true";
import { default as registered_45edit_45form5T212cv_JhNwE65iIjy5ShJbdWDi_S93igR6Lax3ErwMeta } from "/app/src/pages/registered-edit/schemas/registered-edit-form.ts?macro=true";
import { default as parameter_45search_45formaRlu0QvWrO55ULJAptBhJDukxo0H35U7plLlS8fwz4kMeta } from "/app/src/pages/admin/parameter/schemas/parameter-search-form.ts?macro=true";
import { default as product_45versionCT8bcUZd8tWBU8PPMLlG_XiqTa0KiLtA1hm8K_458muLMMeta } from "/app/src/pages/admin/productMain/components/product-version.vue?macro=true";
import { default as search_45panelzBqJxzZq3BIgSLGGQeZ5M4MI5hTxXjDOe9GQsfKcgFoMeta } from "/app/src/pages/admin/productSubPage/components/search-panel.vue?macro=true";
import { default as product_45navs_45search_45form_3Yr5HU6gUFwPJBSk0_OqRxZgTxLdTy3Itod31eTBIoMeta } from "/app/src/pages/product-navs/schemas/product-navs-search-form.ts?macro=true";
import { default as account_45formExCnVBirauEaRm04I2JiJ53skFfgN_45PtuD_zdHvsJfMMeta } from "/app/src/pages/admin/personal/components/schemas/account-form.ts?macro=true";
import { default as action_45buttonsgG5auJJDhzS4Q8W1S_NJydtJzg6_453DigbqKqEqEEKqwMeta } from "/app/src/pages/admin/productSubPage/components/action-buttons.vue?macro=true";
import { default as put_45data_45modalSX8AArqcaN_AcdN37J8HHFmm0YOMs_ENMJidPFTwE8IMeta } from "/app/src/pages/admin/productSubPage/components/put-data-modal.vue?macro=true";
import { default as product_45pages_45formwji53znJ_45C5bb3meLAzppQ7dqC8lNQctc17zDfVfb8YMeta } from "/app/src/pages/admin/productSubPage/schemas/product-pages-form.ts?macro=true";
import { default as service_45issue_45search_45formV9_45T6XopWJdzwFJF2fF624O0qyev0DVcVt3evvk1hzkMeta } from "/app/src/pages/admin/service/schemas/service-issue-search-form.ts?macro=true";
import { default as edit_45content_45modal_3UbcveJDNlU_nGHmic1Un5Lt4Y5uhTAFFm9Ai_45ljoAMeta } from "/app/src/pages/admin/productMain/components/edit-content-modal.vue?macro=true";
import { default as product_45sub_45search_45formfQI0n4n8C1OGxWoVEsQG1VKDWpDffOQgqu_4I6OjyrkMeta } from "/app/src/pages/admin/productSub/schemas/product-sub-search-form.ts?macro=true";
import { default as edit_45parameterm_45modal3am_456BdnEruxKk6rAdkxXsqdl7okYz1qUoVsJ1LnQIcMeta } from "/app/src/pages/admin/parameter/components/edit-parameterm-modal.vue?macro=true";
import { default as sub_45item_45create_45formIh0I7Zb17HJ3kwQMH7JmBAUjNkgEBYVtV_45fimPvd3VEMeta } from "/app/src/pages/admin/productSub/components/sub-item-create-form.vue?macro=true";
import { default as product_45main_45search_45formgQ0P_L3uJ_4L6fMX2P8w8vxt8TX9tqOrpJbjAgfgA_45AMeta } from "/app/src/pages/admin/productMain/schemas/product-main-search-form.ts?macro=true";
import { default as product_45main_45content_45formNrFb02fWl49VAarWo_kg6RQcG_45_45ieB_VAAk_amSH1TYMeta } from "/app/src/pages/admin/productMain/schemas/product-main-content-form.ts?macro=true";
import { default as product_45sub_45page_45search_45form9Yw1U_jtUahOzHUjr9B62UOLKu6RhjK_45VvKfdqOHTrIMeta } from "/app/src/pages/admin/productSubPage/schemas/product-sub-page-search-form.ts?macro=true";
import { default as edit_45production_45inner_45modalSvWlVauqMZcolwyo3dTt7jS08aAnZBsjF2ltCSnzsfAMeta } from "/app/src/pages/admin/productSubPage/components/edit-production-inner-modal.vue?macro=true";
export default [
  {
    name: "index___tw",
    path: "/",
    meta: indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta || {},
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "slug___tw",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93z2ulRrSyHEiAZI_45QPu61kAXVIQtxyzT9Tt2nhVlsYzsMeta || {},
    component: () => import("/app/src/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93z2ulRrSyHEiAZI_45QPu61kAXVIQtxyzT9Tt2nhVlsYzsMeta || {},
    component: () => import("/app/src/pages/[...slug].vue")
  },
  {
    name: "sign___tw",
    path: "/sign",
    meta: indexW_cgUCxiKEsX3OaTBxYnTPyCj1VkbSbDnLILAJSgxrwMeta || {},
    component: () => import("/app/src/pages/sign/index.vue")
  },
  {
    name: "sign___en",
    path: "/en/sign",
    meta: indexW_cgUCxiKEsX3OaTBxYnTPyCj1VkbSbDnLILAJSgxrwMeta || {},
    component: () => import("/app/src/pages/sign/index.vue")
  },
  {
    name: "admin___tw",
    path: "/admin",
    meta: indexaIvZKiUinKzPWcX_451DuzdmUcwdr_45KqxLB4z_452JO2d_oMeta || {},
    component: () => import("/app/src/pages/admin/index.vue")
  },
  {
    name: "admin___en",
    path: "/en/admin",
    meta: indexaIvZKiUinKzPWcX_451DuzdmUcwdr_45KqxLB4z_452JO2d_oMeta || {},
    component: () => import("/app/src/pages/admin/index.vue")
  },
  {
    name: "forget___tw",
    path: "/forget",
    meta: indexMEfzbVVEb8GO8kjTsiwwhkij_459EAb3qez75uIYtV6HQMeta || {},
    component: () => import("/app/src/pages/forget/index.vue")
  },
  {
    name: "forget___en",
    path: "/en/forget",
    meta: indexMEfzbVVEb8GO8kjTsiwwhkij_459EAb3qez75uIYtV6HQMeta || {},
    component: () => import("/app/src/pages/forget/index.vue")
  },
  {
    name: "submit___tw",
    path: "/submit",
    meta: indexwQ0whIx6V6QO__452fQ6F7yUrPqrky8Q7byXKWp27tiNsMeta || {},
    component: () => import("/app/src/pages/submit/index.vue")
  },
  {
    name: "submit___en",
    path: "/en/submit",
    meta: indexwQ0whIx6V6QO__452fQ6F7yUrPqrky8Q7byXKWp27tiNsMeta || {},
    component: () => import("/app/src/pages/submit/index.vue")
  },
  {
    name: "inquire___tw",
    path: "/inquire",
    meta: indexTzMaNAylP955S0lE9D4403QCGYEEd4736PI_3QWcPBAMeta || {},
    component: () => import("/app/src/pages/inquire/index.vue")
  },
  {
    name: "inquire___en",
    path: "/en/inquire",
    meta: indexTzMaNAylP955S0lE9D4403QCGYEEd4736PI_3QWcPBAMeta || {},
    component: () => import("/app/src/pages/inquire/index.vue")
  },
  {
    name: "question___tw",
    path: "/question",
    meta: indexBNM4uTueJp3DaGD_GkH6jtybK42fjjNJMxMR35erPnEMeta || {},
    component: () => import("/app/src/pages/question/index.vue")
  },
  {
    name: "question___en",
    path: "/en/question",
    meta: indexBNM4uTueJp3DaGD_GkH6jtybK42fjjNJMxMR35erPnEMeta || {},
    component: () => import("/app/src/pages/question/index.vue")
  },
  {
    name: "recording-id___tw",
    path: "/recording/:id()",
    meta: _91id_93E5Vc3RHPRwKjq8ZucZ_X0eQw2nQQuUcLL7jLu7ek3OMMeta || {},
    component: () => import("/app/src/pages/recording/[id].vue")
  },
  {
    name: "recording-id___en",
    path: "/en/recording/:id()",
    meta: _91id_93E5Vc3RHPRwKjq8ZucZ_X0eQw2nQQuUcLL7jLu7ek3OMMeta || {},
    component: () => import("/app/src/pages/recording/[id].vue")
  },
  {
    name: "admin-role___tw",
    path: "/admin/role",
    meta: indexOaydxna2dgjeAQAgJ5FQQoDerWdOZ4Kl8XBPszjzd_45AMeta || {},
    component: () => import("/app/src/pages/admin/role/index.vue")
  },
  {
    name: "admin-role___en",
    path: "/en/admin/role",
    meta: indexOaydxna2dgjeAQAgJ5FQQoDerWdOZ4Kl8XBPszjzd_45AMeta || {},
    component: () => import("/app/src/pages/admin/role/index.vue")
  },
  {
    name: "registered___tw",
    path: "/registered",
    meta: indexKRGDHoNYJuDPM0ps4vzL9h42MYFEWt_A6T2NmURkz0AMeta || {},
    component: () => import("/app/src/pages/registered/index.vue")
  },
  {
    name: "registered___en",
    path: "/en/registered",
    meta: indexKRGDHoNYJuDPM0ps4vzL9h42MYFEWt_A6T2NmURkz0AMeta || {},
    component: () => import("/app/src/pages/registered/index.vue")
  },
  {
    name: "product-list___tw",
    path: "/product-list/:id()",
    meta: _91id_93n_45thbf4RKLEdlEyNZqErRJptuAGO4e5l5RoBU6e0m6YMeta || {},
    component: () => import("/app/src/pages/product-list/[id].vue")
  },
  {
    name: "product-list___en",
    path: "/en/product-list/:id()",
    meta: _91id_93n_45thbf4RKLEdlEyNZqErRJptuAGO4e5l5RoBU6e0m6YMeta || {},
    component: () => import("/app/src/pages/product-list/[id].vue")
  },
  {
    name: "admin-account___tw",
    path: "/admin/account",
    meta: indexZ7SxwOlWjEqtYCBP_45BVZAwrioXfIPs1ZtUqTVl2biq4Meta || {},
    component: () => import("/app/src/pages/admin/account/index.vue")
  },
  {
    name: "admin-account___en",
    path: "/en/admin/account",
    meta: indexZ7SxwOlWjEqtYCBP_45BVZAwrioXfIPs1ZtUqTVl2biq4Meta || {},
    component: () => import("/app/src/pages/admin/account/index.vue")
  },
  {
    name: "admin-service___tw",
    path: "/admin/service",
    meta: indexh_2O6cLR31LBdcKHUEdim26AJ0McfzH4xnn4iZBnRgUMeta || {},
    component: () => import("/app/src/pages/admin/service/index.vue")
  },
  {
    name: "admin-service___en",
    path: "/en/admin/service",
    meta: indexh_2O6cLR31LBdcKHUEdim26AJ0McfzH4xnn4iZBnRgUMeta || {},
    component: () => import("/app/src/pages/admin/service/index.vue")
  },
  {
    name: "admin-personal___tw",
    path: "/admin/personal",
    meta: indexTCP4QyYYJP5uDm8iHa_Cczy6BQqvIK8X67a54gsJlr0Meta || {},
    component: () => import("/app/src/pages/admin/personal/index.vue")
  },
  {
    name: "admin-personal___en",
    path: "/en/admin/personal",
    meta: indexTCP4QyYYJP5uDm8iHa_Cczy6BQqvIK8X67a54gsJlr0Meta || {},
    component: () => import("/app/src/pages/admin/personal/index.vue")
  },
  {
    name: "product-article-id___tw",
    path: "/product-article/:id()",
    meta: _91id_93aF9i4iWA_oEiwIzG0bvSpY9KhrclrLDIsG5KWQl_45RX4Meta || {},
    component: () => import("/app/src/pages/product-article/[id].vue")
  },
  {
    name: "product-article-id___en",
    path: "/en/product-article/:id()",
    meta: _91id_93aF9i4iWA_oEiwIzG0bvSpY9KhrclrLDIsG5KWQl_45RX4Meta || {},
    component: () => import("/app/src/pages/product-article/[id].vue")
  },
  {
    name: "admin-parameter___tw",
    path: "/admin/parameter",
    meta: index_NzYC63wGK_o0CY7bKWmrS0vZzw_31JhpgW34FUpAEYMeta || {},
    component: () => import("/app/src/pages/admin/parameter/index.vue")
  },
  {
    name: "admin-parameter___en",
    path: "/en/admin/parameter",
    meta: index_NzYC63wGK_o0CY7bKWmrS0vZzw_31JhpgW34FUpAEYMeta || {},
    component: () => import("/app/src/pages/admin/parameter/index.vue")
  },
  {
    name: "registered-edit___tw",
    path: "/registered-edit",
    meta: indexu1kzx0bNSnMSO_NU2VnfviXuZOdWDnQRas98ndteW9EMeta || {},
    component: () => import("/app/src/pages/registered-edit/index.vue")
  },
  {
    name: "registered-edit___en",
    path: "/en/registered-edit",
    meta: indexu1kzx0bNSnMSO_NU2VnfviXuZOdWDnQRas98ndteW9EMeta || {},
    component: () => import("/app/src/pages/registered-edit/index.vue")
  },
  {
    name: "sign-schemas-sign-form___tw",
    path: "/sign/schemas/sign-form",
    component: () => import("/app/src/pages/sign/schemas/sign-form.ts")
  },
  {
    name: "sign-schemas-sign-form___en",
    path: "/en/sign/schemas/sign-form",
    component: () => import("/app/src/pages/sign/schemas/sign-form.ts")
  },
  {
    name: "admin-productSub___tw",
    path: "/admin/productSub",
    meta: indexv_45GwsW4mjU89LYZv6alFwrQ_45u622y_45k3OO_1DUj3F3EMeta || {},
    component: () => import("/app/src/pages/admin/productSub/index.vue")
  },
  {
    name: "admin-productSub___en",
    path: "/en/admin/productSub",
    meta: indexv_45GwsW4mjU89LYZv6alFwrQ_45u622y_45k3OO_1DUj3F3EMeta || {},
    component: () => import("/app/src/pages/admin/productSub/index.vue")
  },
  {
    name: "admin-productMain___tw",
    path: "/admin/productMain",
    meta: indexm3QSdkNa6zy9PrVKmAmPnvgb66tbXy45fxGN84dH5C0Meta || {},
    component: () => import("/app/src/pages/admin/productMain/index.vue")
  },
  {
    name: "admin-productMain___en",
    path: "/en/admin/productMain",
    meta: indexm3QSdkNa6zy9PrVKmAmPnvgb66tbXy45fxGN84dH5C0Meta || {},
    component: () => import("/app/src/pages/admin/productMain/index.vue")
  },
  {
    name: "recording-inquire___tw",
    path: "/recording-inquire",
    meta: index0RjoNJYiXXmUlxRZ5uWhi6W1TLUytcSOEClg8Q41nTUMeta || {},
    component: () => import("/app/src/pages/recording-inquire/index.vue")
  },
  {
    name: "recording-inquire___en",
    path: "/en/recording-inquire",
    meta: index0RjoNJYiXXmUlxRZ5uWhi6W1TLUytcSOEClg8Q41nTUMeta || {},
    component: () => import("/app/src/pages/recording-inquire/index.vue")
  },
  {
    name: "forget-schemas-forget-form___tw",
    path: "/forget/schemas/forget-form",
    component: () => import("/app/src/pages/forget/schemas/forget-form.ts")
  },
  {
    name: "forget-schemas-forget-form___en",
    path: "/en/forget/schemas/forget-form",
    component: () => import("/app/src/pages/forget/schemas/forget-form.ts")
  },
  {
    name: "submit-schemas-submit-form___tw",
    path: "/submit/schemas/submit-form",
    component: () => import("/app/src/pages/submit/schemas/submit-form.ts")
  },
  {
    name: "submit-schemas-submit-form___en",
    path: "/en/submit/schemas/submit-form",
    component: () => import("/app/src/pages/submit/schemas/submit-form.ts")
  },
  {
    name: "admin-productSubPage___tw",
    path: "/admin/productSubPage",
    meta: index57REhusMqHdYlnupBbPTwL1f3qWFBMHl5Mdm4GIuCqIMeta || {},
    component: () => import("/app/src/pages/admin/productSubPage/index.vue")
  },
  {
    name: "admin-productSubPage___en",
    path: "/en/admin/productSubPage",
    meta: index57REhusMqHdYlnupBbPTwL1f3qWFBMHl5Mdm4GIuCqIMeta || {},
    component: () => import("/app/src/pages/admin/productSubPage/index.vue")
  },
  {
    name: "product-navs-pmID-psID___tw",
    path: "/product-navs/:pmID()/:psID()",
    meta: _91psID_93Ae3HCo_454cocyYwLz86TrtsFMh9d8E3wPFhgMxqXQ_45Q8Meta || {},
    component: () => import("/app/src/pages/product-navs/[pmID]/[psID].vue")
  },
  {
    name: "product-navs-pmID-psID___en",
    path: "/en/product-navs/:pmID()/:psID()",
    meta: _91psID_93Ae3HCo_454cocyYwLz86TrtsFMh9d8E3wPFhgMxqXQ_45Q8Meta || {},
    component: () => import("/app/src/pages/product-navs/[pmID]/[psID].vue")
  },
  {
    name: "admin-role-schemas-role-form___tw",
    path: "/admin/role/schemas/role-form",
    component: () => import("/app/src/pages/admin/role/schemas/role-form.ts")
  },
  {
    name: "admin-role-schemas-role-form___en",
    path: "/en/admin/role/schemas/role-form",
    component: () => import("/app/src/pages/admin/role/schemas/role-form.ts")
  },
  {
    name: "recording-components-reply-form___tw",
    path: "/recording/components/reply-form",
    component: () => import("/app/src/pages/recording/components/reply-form.vue")
  },
  {
    name: "recording-components-reply-form___en",
    path: "/en/recording/components/reply-form",
    component: () => import("/app/src/pages/recording/components/reply-form.vue")
  },
  {
    name: "registered-schemas-register-form___tw",
    path: "/registered/schemas/register-form",
    component: () => import("/app/src/pages/registered/schemas/register-form.ts")
  },
  {
    name: "registered-schemas-register-form___en",
    path: "/en/registered/schemas/register-form",
    component: () => import("/app/src/pages/registered/schemas/register-form.ts")
  },
  {
    name: "submit-components-file-uploader___tw",
    path: "/submit/components/file-uploader",
    component: () => import("/app/src/pages/submit/components/file-uploader.vue")
  },
  {
    name: "submit-components-file-uploader___en",
    path: "/en/submit/components/file-uploader",
    component: () => import("/app/src/pages/submit/components/file-uploader.vue")
  },
  {
    name: "admin-account-schemas-account-form___tw",
    path: "/admin/account/schemas/account-form",
    component: () => import("/app/src/pages/admin/account/schemas/account-form.ts")
  },
  {
    name: "admin-account-schemas-account-form___en",
    path: "/en/admin/account/schemas/account-form",
    component: () => import("/app/src/pages/admin/account/schemas/account-form.ts")
  },
  {
    name: "admin-service-components-log-form___tw",
    path: "/admin/service/components/log-form",
    component: () => import("/app/src/pages/admin/service/components/log-form.vue")
  },
  {
    name: "admin-service-components-log-form___en",
    path: "/en/admin/service/components/log-form",
    component: () => import("/app/src/pages/admin/service/components/log-form.vue")
  },
  {
    name: "registered-schemas-registered-form___tw",
    path: "/registered/schemas/registered-form",
    component: () => import("/app/src/pages/registered/schemas/registered-form.ts")
  },
  {
    name: "registered-schemas-registered-form___en",
    path: "/en/registered/schemas/registered-form",
    component: () => import("/app/src/pages/registered/schemas/registered-form.ts")
  },
  {
    name: "admin-role-components-search-panel___tw",
    path: "/admin/role/components/search-panel",
    component: () => import("/app/src/pages/admin/role/components/search-panel.vue")
  },
  {
    name: "admin-role-components-search-panel___en",
    path: "/en/admin/role/components/search-panel",
    component: () => import("/app/src/pages/admin/role/components/search-panel.vue")
  },
  {
    name: "admin-role-schemas-role-search-form___tw",
    path: "/admin/role/schemas/role-search-form",
    component: () => import("/app/src/pages/admin/role/schemas/role-search-form.ts")
  },
  {
    name: "admin-role-schemas-role-search-form___en",
    path: "/en/admin/role/schemas/role-search-form",
    component: () => import("/app/src/pages/admin/role/schemas/role-search-form.ts")
  },
  {
    name: "recording-schemas-reply-form-schema___tw",
    path: "/recording/schemas/reply-form-schema",
    component: () => import("/app/src/pages/recording/schemas/reply-form-schema.ts")
  },
  {
    name: "recording-schemas-reply-form-schema___en",
    path: "/en/recording/schemas/reply-form-schema",
    component: () => import("/app/src/pages/recording/schemas/reply-form-schema.ts")
  },
  {
    name: "submit-components-select-component___tw",
    path: "/submit/components/select-component",
    component: () => import("/app/src/pages/submit/components/select-component.vue")
  },
  {
    name: "submit-components-select-component___en",
    path: "/en/submit/components/select-component",
    component: () => import("/app/src/pages/submit/components/select-component.vue")
  },
  {
    name: "admin-personal-components-form-data___tw",
    path: "/admin/personal/components/form-data",
    component: () => import("/app/src/pages/admin/personal/components/form-data.vue")
  },
  {
    name: "admin-personal-components-form-data___en",
    path: "/en/admin/personal/components/form-data",
    component: () => import("/app/src/pages/admin/personal/components/form-data.vue")
  },
  {
    name: "admin-service-components-log-record___tw",
    path: "/admin/service/components/log-record",
    component: () => import("/app/src/pages/admin/service/components/log-record.vue")
  },
  {
    name: "admin-service-components-log-record___en",
    path: "/en/admin/service/components/log-record",
    component: () => import("/app/src/pages/admin/service/components/log-record.vue")
  },
  {
    name: "admin-role-components-action-buttons___tw",
    path: "/admin/role/components/action-buttons",
    component: () => import("/app/src/pages/admin/role/components/action-buttons.vue")
  },
  {
    name: "admin-role-components-action-buttons___en",
    path: "/en/admin/role/components/action-buttons",
    component: () => import("/app/src/pages/admin/role/components/action-buttons.vue")
  },
  {
    name: "admin-role-components-put-data-modal___tw",
    path: "/admin/role/components/put-data-modal",
    component: () => import("/app/src/pages/admin/role/components/put-data-modal.vue")
  },
  {
    name: "admin-role-components-put-data-modal___en",
    path: "/en/admin/role/components/put-data-modal",
    component: () => import("/app/src/pages/admin/role/components/put-data-modal.vue")
  },
  {
    name: "admin-service-components-alert-modal___tw",
    path: "/admin/service/components/alert-modal",
    component: () => import("/app/src/pages/admin/service/components/alert-modal.vue")
  },
  {
    name: "admin-service-components-alert-modal___en",
    path: "/en/admin/service/components/alert-modal",
    component: () => import("/app/src/pages/admin/service/components/alert-modal.vue")
  },
  {
    name: "registered-schemas-register-edit-form___tw",
    path: "/registered/schemas/register-edit-form",
    component: () => import("/app/src/pages/registered/schemas/register-edit-form.ts")
  },
  {
    name: "registered-schemas-register-edit-form___en",
    path: "/en/registered/schemas/register-edit-form",
    component: () => import("/app/src/pages/registered/schemas/register-edit-form.ts")
  },
  {
    name: "admin-account-components-search-panel___tw",
    path: "/admin/account/components/search-panel",
    component: () => import("/app/src/pages/admin/account/components/search-panel.vue")
  },
  {
    name: "admin-account-components-search-panel___en",
    path: "/en/admin/account/components/search-panel",
    component: () => import("/app/src/pages/admin/account/components/search-panel.vue")
  },
  {
    name: "admin-parameter-schemas-parameter-form___tw",
    path: "/admin/parameter/schemas/parameter-form",
    component: () => import("/app/src/pages/admin/parameter/schemas/parameter-form.ts")
  },
  {
    name: "admin-parameter-schemas-parameter-form___en",
    path: "/en/admin/parameter/schemas/parameter-form",
    component: () => import("/app/src/pages/admin/parameter/schemas/parameter-form.ts")
  },
  {
    name: "admin-service-components-button-panel___tw",
    path: "/admin/service/components/button-panel",
    component: () => import("/app/src/pages/admin/service/components/button-panel.vue")
  },
  {
    name: "admin-service-components-button-panel___en",
    path: "/en/admin/service/components/button-panel",
    component: () => import("/app/src/pages/admin/service/components/button-panel.vue")
  },
  {
    name: "admin-service-components-search-panel___tw",
    path: "/admin/service/components/search-panel",
    component: () => import("/app/src/pages/admin/service/components/search-panel.vue")
  },
  {
    name: "admin-service-components-search-panel___en",
    path: "/en/admin/service/components/search-panel",
    component: () => import("/app/src/pages/admin/service/components/search-panel.vue")
  },
  {
    name: "admin-service-schemas-service-log-form___tw",
    path: "/admin/service/schemas/service-log-form",
    component: () => import("/app/src/pages/admin/service/schemas/service-log-form.ts")
  },
  {
    name: "admin-service-schemas-service-log-form___en",
    path: "/en/admin/service/schemas/service-log-form",
    component: () => import("/app/src/pages/admin/service/schemas/service-log-form.ts")
  },
  {
    name: "product-list-components-content-cover___tw",
    path: "/product-list/components/content-cover",
    component: () => import("/app/src/pages/product-list/components/content-cover.vue")
  },
  {
    name: "product-list-components-content-cover___en",
    path: "/en/product-list/components/content-cover",
    component: () => import("/app/src/pages/product-list/components/content-cover.vue")
  },
  {
    name: "admin-account-components-action-buttons___tw",
    path: "/admin/account/components/action-buttons",
    component: () => import("/app/src/pages/admin/account/components/action-buttons.vue")
  },
  {
    name: "admin-account-components-action-buttons___en",
    path: "/en/admin/account/components/action-buttons",
    component: () => import("/app/src/pages/admin/account/components/action-buttons.vue")
  },
  {
    name: "admin-account-components-put-data-modal___tw",
    path: "/admin/account/components/put-data-modal",
    component: () => import("/app/src/pages/admin/account/components/put-data-modal.vue")
  },
  {
    name: "admin-account-components-put-data-modal___en",
    path: "/en/admin/account/components/put-data-modal",
    component: () => import("/app/src/pages/admin/account/components/put-data-modal.vue")
  },
  {
    name: "admin-parameter-components-search-panel___tw",
    path: "/admin/parameter/components/search-panel",
    component: () => import("/app/src/pages/admin/parameter/components/search-panel.vue")
  },
  {
    name: "admin-parameter-components-search-panel___en",
    path: "/en/admin/parameter/components/search-panel",
    component: () => import("/app/src/pages/admin/parameter/components/search-panel.vue")
  },
  {
    name: "admin-role-components-delete-data-modal___tw",
    path: "/admin/role/components/delete-data-modal",
    component: () => import("/app/src/pages/admin/role/components/delete-data-modal.vue")
  },
  {
    name: "admin-role-components-delete-data-modal___en",
    path: "/en/admin/role/components/delete-data-modal",
    component: () => import("/app/src/pages/admin/role/components/delete-data-modal.vue")
  },
  {
    name: "admin-service-components-put-data-modal___tw",
    path: "/admin/service/components/put-data-modal",
    component: () => import("/app/src/pages/admin/service/components/put-data-modal.vue")
  },
  {
    name: "admin-service-components-put-data-modal___en",
    path: "/en/admin/service/components/put-data-modal",
    component: () => import("/app/src/pages/admin/service/components/put-data-modal.vue")
  },
  {
    name: "admin-service-schemas-service-issue-form___tw",
    path: "/admin/service/schemas/service-issue-form",
    component: () => import("/app/src/pages/admin/service/schemas/service-issue-form.ts")
  },
  {
    name: "admin-service-schemas-service-issue-form___en",
    path: "/en/admin/service/schemas/service-issue-form",
    component: () => import("/app/src/pages/admin/service/schemas/service-issue-form.ts")
  },
  {
    name: "recording-components-feedback-component___tw",
    path: "/recording/components/feedback-component",
    component: () => import("/app/src/pages/recording/components/feedback-component.vue")
  },
  {
    name: "recording-components-feedback-component___en",
    path: "/en/recording/components/feedback-component",
    component: () => import("/app/src/pages/recording/components/feedback-component.vue")
  },
  {
    name: "recording-components-progress-component___tw",
    path: "/recording/components/progress-component",
    component: () => import("/app/src/pages/recording/components/progress-component.vue")
  },
  {
    name: "recording-components-progress-component___en",
    path: "/en/recording/components/progress-component",
    component: () => import("/app/src/pages/recording/components/progress-component.vue")
  },
  {
    name: "admin-account-schemas-account-search-form___tw",
    path: "/admin/account/schemas/account-search-form",
    component: () => import("/app/src/pages/admin/account/schemas/account-search-form.ts")
  },
  {
    name: "admin-account-schemas-account-search-form___en",
    path: "/en/admin/account/schemas/account-search-form",
    component: () => import("/app/src/pages/admin/account/schemas/account-search-form.ts")
  },
  {
    name: "admin-productSub-components-search-panel___tw",
    path: "/admin/productSub/components/search-panel",
    component: () => import("/app/src/pages/admin/productSub/components/search-panel.vue")
  },
  {
    name: "admin-productSub-components-search-panel___en",
    path: "/en/admin/productSub/components/search-panel",
    component: () => import("/app/src/pages/admin/productSub/components/search-panel.vue")
  },
  {
    name: "admin-productSub-schemas-product-sub-form___tw",
    path: "/admin/productSub/schemas/product-sub-form",
    component: () => import("/app/src/pages/admin/productSub/schemas/product-sub-form.ts")
  },
  {
    name: "admin-productSub-schemas-product-sub-form___en",
    path: "/en/admin/productSub/schemas/product-sub-form",
    component: () => import("/app/src/pages/admin/productSub/schemas/product-sub-form.ts")
  },
  {
    name: "admin-parameter-components-action-buttons___tw",
    path: "/admin/parameter/components/action-buttons",
    component: () => import("/app/src/pages/admin/parameter/components/action-buttons.vue")
  },
  {
    name: "admin-parameter-components-action-buttons___en",
    path: "/en/admin/parameter/components/action-buttons",
    component: () => import("/app/src/pages/admin/parameter/components/action-buttons.vue")
  },
  {
    name: "admin-parameter-components-put-data-modal___tw",
    path: "/admin/parameter/components/put-data-modal",
    component: () => import("/app/src/pages/admin/parameter/components/put-data-modal.vue")
  },
  {
    name: "admin-parameter-components-put-data-modal___en",
    path: "/en/admin/parameter/components/put-data-modal",
    component: () => import("/app/src/pages/admin/parameter/components/put-data-modal.vue")
  },
  {
    name: "admin-productMain-components-search-panel___tw",
    path: "/admin/productMain/components/search-panel",
    component: () => import("/app/src/pages/admin/productMain/components/search-panel.vue")
  },
  {
    name: "admin-productMain-components-search-panel___en",
    path: "/en/admin/productMain/components/search-panel",
    component: () => import("/app/src/pages/admin/productMain/components/search-panel.vue")
  },
  {
    name: "admin-productSub-components-sub-item-list___tw",
    path: "/admin/productSub/components/sub-item-list",
    component: () => import("/app/src/pages/admin/productSub/components/sub-item-list.vue")
  },
  {
    name: "admin-productSub-components-sub-item-list___en",
    path: "/en/admin/productSub/components/sub-item-list",
    component: () => import("/app/src/pages/admin/productSub/components/sub-item-list.vue")
  },
  {
    name: "admin-productMain-schemas-product-main-form___tw",
    path: "/admin/productMain/schemas/product-main-form",
    component: () => import("/app/src/pages/admin/productMain/schemas/product-main-form.ts")
  },
  {
    name: "admin-productMain-schemas-product-main-form___en",
    path: "/en/admin/productMain/schemas/product-main-form",
    component: () => import("/app/src/pages/admin/productMain/schemas/product-main-form.ts")
  },
  {
    name: "admin-productSub-components-action-buttons___tw",
    path: "/admin/productSub/components/action-buttons",
    component: () => import("/app/src/pages/admin/productSub/components/action-buttons.vue")
  },
  {
    name: "admin-productSub-components-action-buttons___en",
    path: "/en/admin/productSub/components/action-buttons",
    component: () => import("/app/src/pages/admin/productSub/components/action-buttons.vue")
  },
  {
    name: "admin-productSub-components-put-data-modal___tw",
    path: "/admin/productSub/components/put-data-modal",
    component: () => import("/app/src/pages/admin/productSub/components/put-data-modal.vue")
  },
  {
    name: "admin-productSub-components-put-data-modal___en",
    path: "/en/admin/productSub/components/put-data-modal",
    component: () => import("/app/src/pages/admin/productSub/components/put-data-modal.vue")
  },
  {
    name: "admin-productMain-components-action-buttons___tw",
    path: "/admin/productMain/components/action-buttons",
    component: () => import("/app/src/pages/admin/productMain/components/action-buttons.vue")
  },
  {
    name: "admin-productMain-components-action-buttons___en",
    path: "/en/admin/productMain/components/action-buttons",
    component: () => import("/app/src/pages/admin/productMain/components/action-buttons.vue")
  },
  {
    name: "admin-productMain-components-put-data-modal___tw",
    path: "/admin/productMain/components/put-data-modal",
    component: () => import("/app/src/pages/admin/productMain/components/put-data-modal.vue")
  },
  {
    name: "admin-productMain-components-put-data-modal___en",
    path: "/en/admin/productMain/components/put-data-modal",
    component: () => import("/app/src/pages/admin/productMain/components/put-data-modal.vue")
  },
  {
    name: "registered-edit-schemas-registered-edit-form___tw",
    path: "/registered-edit/schemas/registered-edit-form",
    component: () => import("/app/src/pages/registered-edit/schemas/registered-edit-form.ts")
  },
  {
    name: "registered-edit-schemas-registered-edit-form___en",
    path: "/en/registered-edit/schemas/registered-edit-form",
    component: () => import("/app/src/pages/registered-edit/schemas/registered-edit-form.ts")
  },
  {
    name: "admin-parameter-schemas-parameter-search-form___tw",
    path: "/admin/parameter/schemas/parameter-search-form",
    component: () => import("/app/src/pages/admin/parameter/schemas/parameter-search-form.ts")
  },
  {
    name: "admin-parameter-schemas-parameter-search-form___en",
    path: "/en/admin/parameter/schemas/parameter-search-form",
    component: () => import("/app/src/pages/admin/parameter/schemas/parameter-search-form.ts")
  },
  {
    name: "admin-productMain-components-product-version___tw",
    path: "/admin/productMain/components/product-version",
    component: () => import("/app/src/pages/admin/productMain/components/product-version.vue")
  },
  {
    name: "admin-productMain-components-product-version___en",
    path: "/en/admin/productMain/components/product-version",
    component: () => import("/app/src/pages/admin/productMain/components/product-version.vue")
  },
  {
    name: "admin-productSubPage-components-search-panel___tw",
    path: "/admin/productSubPage/components/search-panel",
    component: () => import("/app/src/pages/admin/productSubPage/components/search-panel.vue")
  },
  {
    name: "admin-productSubPage-components-search-panel___en",
    path: "/en/admin/productSubPage/components/search-panel",
    component: () => import("/app/src/pages/admin/productSubPage/components/search-panel.vue")
  },
  {
    name: "product-navs-schemas-product-navs-search-form___tw",
    path: "/product-navs/schemas/product-navs-search-form",
    component: () => import("/app/src/pages/product-navs/schemas/product-navs-search-form.ts")
  },
  {
    name: "product-navs-schemas-product-navs-search-form___en",
    path: "/en/product-navs/schemas/product-navs-search-form",
    component: () => import("/app/src/pages/product-navs/schemas/product-navs-search-form.ts")
  },
  {
    name: "admin-personal-components-schemas-account-form___tw",
    path: "/admin/personal/components/schemas/account-form",
    component: () => import("/app/src/pages/admin/personal/components/schemas/account-form.ts")
  },
  {
    name: "admin-personal-components-schemas-account-form___en",
    path: "/en/admin/personal/components/schemas/account-form",
    component: () => import("/app/src/pages/admin/personal/components/schemas/account-form.ts")
  },
  {
    name: "admin-productSubPage-components-action-buttons___tw",
    path: "/admin/productSubPage/components/action-buttons",
    component: () => import("/app/src/pages/admin/productSubPage/components/action-buttons.vue")
  },
  {
    name: "admin-productSubPage-components-action-buttons___en",
    path: "/en/admin/productSubPage/components/action-buttons",
    component: () => import("/app/src/pages/admin/productSubPage/components/action-buttons.vue")
  },
  {
    name: "admin-productSubPage-components-put-data-modal___tw",
    path: "/admin/productSubPage/components/put-data-modal",
    component: () => import("/app/src/pages/admin/productSubPage/components/put-data-modal.vue")
  },
  {
    name: "admin-productSubPage-components-put-data-modal___en",
    path: "/en/admin/productSubPage/components/put-data-modal",
    component: () => import("/app/src/pages/admin/productSubPage/components/put-data-modal.vue")
  },
  {
    name: "admin-productSubPage-schemas-product-pages-form___tw",
    path: "/admin/productSubPage/schemas/product-pages-form",
    component: () => import("/app/src/pages/admin/productSubPage/schemas/product-pages-form.ts")
  },
  {
    name: "admin-productSubPage-schemas-product-pages-form___en",
    path: "/en/admin/productSubPage/schemas/product-pages-form",
    component: () => import("/app/src/pages/admin/productSubPage/schemas/product-pages-form.ts")
  },
  {
    name: "admin-service-schemas-service-issue-search-form___tw",
    path: "/admin/service/schemas/service-issue-search-form",
    component: () => import("/app/src/pages/admin/service/schemas/service-issue-search-form.ts")
  },
  {
    name: "admin-service-schemas-service-issue-search-form___en",
    path: "/en/admin/service/schemas/service-issue-search-form",
    component: () => import("/app/src/pages/admin/service/schemas/service-issue-search-form.ts")
  },
  {
    name: "admin-productMain-components-edit-content-modal___tw",
    path: "/admin/productMain/components/edit-content-modal",
    component: () => import("/app/src/pages/admin/productMain/components/edit-content-modal.vue")
  },
  {
    name: "admin-productMain-components-edit-content-modal___en",
    path: "/en/admin/productMain/components/edit-content-modal",
    component: () => import("/app/src/pages/admin/productMain/components/edit-content-modal.vue")
  },
  {
    name: "admin-productSub-schemas-product-sub-search-form___tw",
    path: "/admin/productSub/schemas/product-sub-search-form",
    component: () => import("/app/src/pages/admin/productSub/schemas/product-sub-search-form.ts")
  },
  {
    name: "admin-productSub-schemas-product-sub-search-form___en",
    path: "/en/admin/productSub/schemas/product-sub-search-form",
    component: () => import("/app/src/pages/admin/productSub/schemas/product-sub-search-form.ts")
  },
  {
    name: "admin-parameter-components-edit-parameterm-modal___tw",
    path: "/admin/parameter/components/edit-parameterm-modal",
    component: () => import("/app/src/pages/admin/parameter/components/edit-parameterm-modal.vue")
  },
  {
    name: "admin-parameter-components-edit-parameterm-modal___en",
    path: "/en/admin/parameter/components/edit-parameterm-modal",
    component: () => import("/app/src/pages/admin/parameter/components/edit-parameterm-modal.vue")
  },
  {
    name: "admin-productSub-components-sub-item-create-form___tw",
    path: "/admin/productSub/components/sub-item-create-form",
    component: () => import("/app/src/pages/admin/productSub/components/sub-item-create-form.vue")
  },
  {
    name: "admin-productSub-components-sub-item-create-form___en",
    path: "/en/admin/productSub/components/sub-item-create-form",
    component: () => import("/app/src/pages/admin/productSub/components/sub-item-create-form.vue")
  },
  {
    name: "admin-productMain-schemas-product-main-search-form___tw",
    path: "/admin/productMain/schemas/product-main-search-form",
    component: () => import("/app/src/pages/admin/productMain/schemas/product-main-search-form.ts")
  },
  {
    name: "admin-productMain-schemas-product-main-search-form___en",
    path: "/en/admin/productMain/schemas/product-main-search-form",
    component: () => import("/app/src/pages/admin/productMain/schemas/product-main-search-form.ts")
  },
  {
    name: "admin-productMain-schemas-product-main-content-form___tw",
    path: "/admin/productMain/schemas/product-main-content-form",
    component: () => import("/app/src/pages/admin/productMain/schemas/product-main-content-form.ts")
  },
  {
    name: "admin-productMain-schemas-product-main-content-form___en",
    path: "/en/admin/productMain/schemas/product-main-content-form",
    component: () => import("/app/src/pages/admin/productMain/schemas/product-main-content-form.ts")
  },
  {
    name: "admin-productSubPage-schemas-product-sub-page-search-form___tw",
    path: "/admin/productSubPage/schemas/product-sub-page-search-form",
    component: () => import("/app/src/pages/admin/productSubPage/schemas/product-sub-page-search-form.ts")
  },
  {
    name: "admin-productSubPage-schemas-product-sub-page-search-form___en",
    path: "/en/admin/productSubPage/schemas/product-sub-page-search-form",
    component: () => import("/app/src/pages/admin/productSubPage/schemas/product-sub-page-search-form.ts")
  },
  {
    name: "admin-productSubPage-components-edit-production-inner-modal___tw",
    path: "/admin/productSubPage/components/edit-production-inner-modal",
    component: () => import("/app/src/pages/admin/productSubPage/components/edit-production-inner-modal.vue")
  },
  {
    name: "admin-productSubPage-components-edit-production-inner-modal___en",
    path: "/en/admin/productSubPage/components/edit-production-inner-modal",
    component: () => import("/app/src/pages/admin/productSubPage/components/edit-production-inner-modal.vue")
  }
]